:host {
  display: block;
}

.spw-field-label {
  color: var(--spw-color-themes-grey-grey-800);
  display: block;
  font-weight: 600;
  @apply spw-tw-mb-2;
  &__required {
    color: var(--spw-ds-primary);
  }
}
